import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { ReviewsItems } from '@gate31/feature/ReviewsItems/ReviewsItems';

export class ReviewsItemsDesk extends ReviewsItems {
    static cn = new BaseJs.BuildCn('ReviewsItemDesk');
}
